<!-- eslint-disable vue/valid-v-slot -->
<template>
	<div>
    <dialog-change-password ref="DialogChangePassword" />
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-select
              v-model="locale"
              :items="$t('settings.languages')"
              :label="$t('settings.language')"
              item-text="value"
              item-value="key"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select
              v-model="theme"
              :items="$t('settings.themes')"
              :label="$t('settings.theme')"
              item-text="value"
              item-value="key"
          ></v-select>
        </v-col>
      </v-row>

    </v-container>

	</div>
</template>

<script>

import DialogChangePassword from "@/components/dialogs/auth/DialogChangePassword.vue"
import { mapActions, mapGetters } from "vuex"


export default {
	name: "AppSettings",
	components: { DialogChangePassword },
	data() {
		return {
      locale: "ru",
      theme: "light",
      }
	},
	methods: {
    ...mapActions('common',["apiBackendSetProperty","apiBackendGetProps"]),
    // ...mapActions('common',["apiBackendSetProperty", "apiBackendChangePassword"]),




	},
	watch: {
    locale(val){
      this.apiBackendSetProperty({property:"language", value: val})
    },

    theme(val){
      this.theme = val
      this.apiBackendSetProperty({property:"theme", value: val})
    }
  },
	computed: {
    ...mapGetters('common',["getUserProps","getUser"]),
    languageProperty(){
      let property = this.getUserProps["language"]
      if (property===null || property===undefined) {
        return "ru"
      }else {
        return property
      }
    },

    themeProperty(){
      let property = this.getUserProps["theme"]
      if (property===null || property===undefined) {
        return "light"
      }else {
        return property
      }
    },
  },

	created() {
    this.theme = this.themeProperty
    this.locale = this.languageProperty

    this.apiBackendGetProps()
  },
}
</script>
